export function getAllStatus() {
    return [
        {
            label: "Brouillon",
            id: "ra_draft",
            spp: false,
        },
        {
            label: "Validée",
            id: "ra_validated",
            spp: false,
        },
        {
            label: "En erreur",
            id: "ra_error",
            spp: false,
        },
        {
            label: "Brouillon",
            id: "spp_draft",
            spp: true,
        },
        {
            label: "En erreur",
            id: "spp_error",
            spp: true,
        },
        {
            label: "Validé",
            id: "spp_validated",
            spp: true,
        },
        {
            label: "Fermé",
            id: "spp_closed",
            spp: true,
        },
        {
            label: "Annulé",
            id: "spp_cancelled",
            spp: true,
        },
    ];
}

export function getStatusLabel(status) {
    if (status === "ra_draft") return "Analyse en brouillon";
    else if (status === "ra_validated") return "Analyse validée";
    else if (status === "ra_error") return "Analyse en erreur";
    else if (status === "spp_draft") return "PPS en brouillon";
    else if (status === "spp_validated") return "PPS validé";
    else if (status === "spp_error") return "PPS en erreur";
    else if (status === "spp_closed") return "PPS refusé";
    else if (status === "spp_cancelled") return "PPS annnulé";
}

export function canImportFromOpenErp(status) {
    return status !== "ra_error" && status !== "spp_error";
}

export function arIsReadonly(header) {
    return (header.status !== "ra_draft" && header.status !== "spp_draft") || header.validationInProgress;
}

export function isPPS(status) {
    return status.startsWith("spp_");
}

export function getColorFromStatusLabel(status, lowlight) {
    if (lowlight) return "grey";

    if (status === "spp_draft" || status === "ra_draft") return "blue";
    else if (status === "spp_validated" || status === "ra_validated") return "green";
    else if (status === "spp_cancelled") return "black";
    else if (status === "spp_closed" || status === "ra_error" || status === "spp_error") return "red";
    else return;
}

export function getIconNameFromStatusLabel(status) {
    if (status === "spp_draft" || status === "ra_draft") return "edit";
    else if (status === "spp_validated" || status === "ra_validated") return "thumb_up";
    else if (status === "spp_cancelled") return "backspace";
    else if (status === "spp_closed") return "thumb_down";
    else if (status === "ra_error" || status === "spp_error") return "warning";
}

export function getMainWorkflowStatus(status) {
    if (isPPS(status)) return getSPPWorkflowStatus(status);
    else return getARWorkflowStatus(status);
}

export function getARWorkflowStatus(status) {
    let allStatus = ["ra_draft"];

    if (status === "ra_error") {
        allStatus.push("ra_error");
        return allStatus;
    }

    allStatus.push("ra_validated");

    return allStatus;
}

export function isInError(status) {
    return status === "ra_error" || status === "spp_error";
}

export function getSPPWorkflowStatus(status) {
    let allStatus = ["spp_draft"];

    if (status === "spp_cancelled") {
        allStatus.push("spp_cancelled");
        return allStatus;
    }

    if (status === "spp_error") {
        allStatus.push("spp_error");
        return allStatus;
    }

    if (status === "spp_closed") {
        allStatus.push("spp_closed");
        return allStatus;
    }

    allStatus.push("spp_validated");
    return allStatus;
}

export function isEditIcon(status) {
    return status === "spp_draft" || status === "ra_draft";
}
